import { render, staticRenderFns } from "./DraftRemoveButton.vue?vue&type=template&id=bddc64ec&scoped=true&"
import script from "./DraftRemoveButton.vue?vue&type=script&lang=js&"
export * from "./DraftRemoveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddc64ec",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VDialog,VIcon,VListItem,VListItemSubtitle})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bddc64ec')) {
      api.createRecord('bddc64ec', component.options)
    } else {
      api.reload('bddc64ec', component.options)
    }
    module.hot.accept("./DraftRemoveButton.vue?vue&type=template&id=bddc64ec&scoped=true&", function () {
      api.rerender('bddc64ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/DraftRemoveButton.vue"
export default component.exports